import { render, staticRenderFns } from "./questionParty.vue?vue&type=template&id=7a24d656&scoped=true&"
import script from "./questionParty.vue?vue&type=script&lang=js&"
export * from "./questionParty.vue?vue&type=script&lang=js&"
import style0 from "./questionParty.vue?vue&type=style&index=0&id=7a24d656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24d656",
  null
  
)

export default component.exports